import { EnviarArpCodigoRequest } from "../pages/home/utils/phoneValidation";
import { api } from "./api";

export async function enviarArpCodigo({
  subscriberId,
  modeloEnvio,
  RecaptchaToken,
  EReenvio,
}: EnviarArpCodigoRequest) {
  try {
    const resp = await api.post(
      "/arpcodigo/enviar/deezer",
      {
        subscriberId,
        modeloEnvio,
        RecaptchaToken,
        EReenvio,
      },
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_AUTHORIZATION_BASIC}`,
          // 'X-Recaptcha-Token': phone.tokenRecaptcha,
          "Content-Type": "application/json",
        },
      }
    );
    return resp;
  } catch (error: any) {
    return error.response;
  }
}